/* eslint-disable prefer-const */
/* eslint-disable consistent-return */
/* eslint-disable func-names */

import  "xlsx";

export type GetMetadataProps = {
  file: string;
  type?: "fetch" | "buffer";
}

export type DataPromiseProps = {
  file: string;
  type: "fetch" | "buffer";
}

export type GetMetadataResponseObject = {
  chapters:any[], metadata: any[]
}

/* set up async GET request */
const fetchOk = (api: string) => fetch(api).then((res) => (res.ok ? res : res.json().then((err) => Promise.reject(err))));


const extractData = (sheet:any, type:"json"|any):GetMetadataResponseObject => {
  const data = { chapters: null, metadata: null };

  console.log(`Extracting Data: ${sheet}`);
  // sheet = Buffer.from(sheet).toJSON()

  if (type === "json") {
    data.chapters = sheet.Chapters.filter((row) => row.Name !== '#REF!');
    data.metadata = sheet.Metadata;
  } else {
    let workbook;
    const xlsx_data = new Uint8Array(sheet);
    // @ts-ignore
    workbook = window.globalThis.XLSX.read(xlsx_data, { type: "array" });

    // debugger;

    /* DO SOMETHING WITH workbook HERE */
    // @ts-ignore
    data.chapters = window.globalThis.XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
    // @ts-ignore
    data.metadata = window.globalThis.XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]]);
  }
  return data;
};

const dataPromise = ({file, type}:DataPromiseProps) => {
  switch (type) {
    case "fetch":
      // debugger;
      console.log("attempting fetch");

      try {
        return fetchOk(file)
          .then((response) => {
            // debugger;
            // return response.arrayBuffer()
            return response.json();
          })
          .then((response) => {
            return extractData(response, "json");
          })
          .catch((e) => {
            // handle the error
            console.log(`fetch.promise: error loading file: ${file}\n${e}`);
          });
      } catch (e) {
        console.log(`fetch: error loading file: ${file}\n${e}`);
      }

      break;
    default:
      return new Promise<GetMetadataResponseObject>((resolve, reject) => {
        try {
          if (typeof file === "string") {
            const req = new XMLHttpRequest();
            req.open("GET", file, true);
            req.responseType = "arraybuffer";

            req.onload = function () {
              if (this.status === 200) {
                try {
                  resolve(extractData(req.response, 'buffer'));
                } catch (e) {
                  console.log(`req.onload: error loading file: ${file}`);
                }
              } else {
                reject(console.log(`req.reject: error loading file: ${file}`));
              }
            };

            req.onerror = function (e) {
              console.log(`req.onerror: error loading file: ${file}\n${e}`);
            };

            req.send();
          } else {
            // @ts-ignore
            resolve(extractData(file, file.constructor === ArrayBuffer ? "bit" : "json"));
          }
        } catch (e) {
          console.log(`error loading file: ${file}`);
        }
      });
  }
};

export const getMetadata = ({file, type}:GetMetadataProps):Promise<GetMetadataResponseObject|void> => {
  type = type ?? "fetch";
  return dataPromise({file, type});
};
